import { createGetDataReducer } from "./CommonReducer";
import { STAFFLIST } from "../../Constants/StaffConstants";

export const StaffGetReducer = createGetDataReducer( STAFFLIST );


